import { render, staticRenderFns } from "./NotDriverMonthlyNetsisScore.vue?vue&type=template&id=5b3ac965&"
import script from "./NotDriverMonthlyNetsisScore.vue?vue&type=script&lang=js&"
export * from "./NotDriverMonthlyNetsisScore.vue?vue&type=script&lang=js&"
import style0 from "./NotDriverMonthlyNetsisScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports